import React, { useEffect, useState } from 'react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Card from '@material-ui/core/Card';
import { useTheme } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import { isEmpty, get } from 'lodash';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useDispatch, useSelector } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { fetchDiscussionData } from '../../../../actions/digitalDiscussionActions';
import { Link } from 'react-router-dom';
import './styles.scss';
import { Grid } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import NoData from '../../../../components/NoData';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PageHeading from '../../../../components/PageHeading';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';
import ScrollToTop from '../../../../components/ScrollToTop';

export default function AddOnClassesLayout() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const [isFetching, setIsFetching] = useState(false);
  const [subject, setsubject] = React.useState('');
  const [showchapters, showChaptersDailog] = React.useState(false);
  const [chapterList, setChapterList] = React.useState([]);
  const [showTopics, showTopicDailog] = React.useState(false);
  const [topicsList, setTopicsList] = React.useState([]);
  const [selectedChapter, setselectedChapter] = React.useState('');
  const [selectedTopic, setselectedTopic] = React.useState('');
  const [visible, setVisible] = React.useState({
    subject: true,
    chapter: false,
    topic: false,
  });
  const dispatch = useDispatch();
  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );

  const digitalClassData = useSelector((state) =>
    get(state, 'digitalDiscussionReducer.data', [])
  );

  const errorMessage = useSelector((state) =>
    get(state, 'digitalDiscussionReducer.errorMessage', '')
  );

  // useEffect(() => {
  //   fetchDiscussionData(jwtToken, dispatch);
  // }, []);

  useEffect(() => {
    setIsFetching(true);
    fetchDiscussionData(jwtToken, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const handleChangeSubject = (event, item) => {
    setsubject(item);
    showTopicDailog(false);
    showChaptersDailog(true);
    setVisible({ subject: false, chapter: true, topic: false });
    fetchChapterList(item);
    setselectedTopic('');
    setselectedChapter('');
  };

  const handleChangeChapter = (event, item) => {
    setselectedChapter(item);
    showTopicDailog(true);
    fetchTopicsList(item);
    setselectedTopic('');
    setVisible({ subject: false, chapter: false, topic: true });
  };

  const handleChangeTopic = (event, item) => {
    setselectedTopic(item);
  };

  const fetchSubjectList = () => {
    const subjects = [];
    digitalClassData.length !== 0 &&
      !isEmpty(digitalClassData) &&
      digitalClassData.map((subject) => {
        subjects.push(subject.SubjectName);
      });
    return subjects;
  };

  const fetchChapterList = (subject) => {
    let listChapterData = [];
    let chapters = [];
    if (subject != '') {
      listChapterData = digitalClassData.filter((item) => {
        return item.SubjectName == subject;
      });
    }
    let classList = listChapterData[0].listChapter;
    classList.length !== 0 &&
      !isEmpty(classList) &&
      classList.map((ch) => {
        chapters.push(ch.ChapterName);
        return chapters;
      });
    setChapterList(chapters);
  };

  const fetchTopicsList = (chapter) => {
    let listSubjectData = [];
    let listChapterData = [];

    if (subject != '' && chapter != '') {
      listSubjectData = digitalClassData.filter((item) => {
        return item.SubjectName == subject;
      });
      listChapterData = listSubjectData[0].listChapter.filter((item) => {
        return item.ChapterName == chapter;
      });
      let classList = listChapterData[0].listClass;
      classList.length !== 0 && !isEmpty(classList) && setTopicsList(classList);
    }
  };

  const subjects = fetchSubjectList();

  const handleBackButton = () => {
    visible.chapter === true
      ? setVisible({ subject: true, chapter: false, topic: false })
      : setVisible({ subject: false, chapter: true, topic: false });
  };

  // For Scroll only in desktop
  const MyScrollBar = matches === true ? PerfectScrollbar : 'div';

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Add On" titleSecondary="Classes" />
      {isFetching ? (
        <LoadingSkeleton type="listItem" />
      ) : !isEmpty(digitalClassData) && digitalClassData.length !== 0 ? (
        <React.Fragment>
          {matches === false && visible.subject === false && (
            <div onClick={handleBackButton} className="back-btn">
              <ArrowBackIcon /> Back
            </div>
          )}
          <Card className="card body-select-dailogs">
            <Grid container className="multiple-list">
              {!(matches === false && visible.subject === false) && (
                <Grid item xs>
                  <div className="list-card-subjects border-none">
                    <MyScrollBar>
                      <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                          <ListSubheader
                            component="div"
                            id="nested-list-subheader"
                          >
                            Select a Subject
                          </ListSubheader>
                        }
                      >
                        <ScrollToTop />
                        {subjects.map((item, index) => (
                          <ListItem
                            button
                            key={index}
                            value={item}
                            onClick={(e) => handleChangeSubject(e, item)}
                          >
                            <ListItemText
                              primary={item}
                              className={item === subject ? 'active' : ''}
                            />
                            <ListItemIcon>
                              <KeyboardArrowRightIcon />
                            </ListItemIcon>
                          </ListItem>
                        ))}
                      </List>
                    </MyScrollBar>
                  </div>
                </Grid>
              )}

              {!(matches === false && visible.chapter === false) &&
                showchapters &&
                chapterList.length != 0 && (
                  <Grid item xs>
                    <div className="list-card-subjects">
                      <MyScrollBar>
                        <List
                          component="nav"
                          aria-labelledby="nested-list-subheader"
                          subheader={
                            <ListSubheader
                              component="div"
                              id="nested-list-subheader"
                            >
                              Select a Topic
                            </ListSubheader>
                          }
                        >
                          <ScrollToTop />
                          {chapterList.map((item, index) => (
                            <ListItem
                              button
                              key={index}
                              value={item}
                              onClick={(e) => handleChangeChapter(e, item)}
                            >
                              <ListItemText
                                primary={item}
                                className={
                                  item === selectedChapter ? 'active' : ''
                                }
                              />
                              <ListItemIcon>
                                <KeyboardArrowRightIcon />
                              </ListItemIcon>
                            </ListItem>
                          ))}
                        </List>
                      </MyScrollBar>
                    </div>
                  </Grid>
                )}
              {!(matches === false && visible.topic === false) &&
                showTopics &&
                topicsList.length != 0 && (
                  <Grid item xs>
                    <div className="list-card-subjects">
                      <MyScrollBar>
                        <List
                          component="nav"
                          aria-labelledby="nested-list-subheader"
                          subheader={
                            <ListSubheader
                              component="div"
                              id="nested-list-subheader"
                            >
                              Select a Class
                            </ListSubheader>
                          }
                        >
                          <ScrollToTop />
                          {topicsList.map((item, index) => (
                            <Link
                              key={item.UniqueCode}
                              to={
                                item.ModuleCode === null
                                  ? '/addon-classes/' + item.UniqueCode
                                  : '/addon-classes/' +
                                    item.UniqueCode +
                                    '/' +
                                    item.ModuleCode
                              }
                            >
                              <ListItem
                                button
                                key={index}
                                value={item.ModuleNo}
                                onClick={(e) =>
                                  handleChangeTopic(e, item.ModuleNo)
                                }
                              >
                                <ListItemText
                                  primary={item.ModuleNo}
                                  className={
                                    item === selectedTopic ? 'active' : ''
                                  }
                                />
                                <ListItemIcon>
                                  <KeyboardArrowRightIcon />
                                </ListItemIcon>
                              </ListItem>
                            </Link>
                          ))}
                        </List>
                      </MyScrollBar>
                    </div>
                  </Grid>
                )}
            </Grid>
          </Card>
        </React.Fragment>
      ) : (
        <NoData
          message={
            !isEmpty(errorMessage) ? errorMessage : 'No data is available'
          }
        />
      )}
    </React.Fragment>
  );
}
